module.exports = __webpack_public_path__ + "static/alarms_ICON-f63437c67b6bc80ec4632a117dd0606e.png";